import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Shield, MailCheck, KeyRound } from "lucide-react";
import Logo from "@/components/Logo";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormCard } from "@/components/FormShell";
import { Label } from "@/components/ui/label";
import { FindoSpinner } from "@/components/FindoSpinner";

export default function SuperadminForgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api("/auth/forgot", { method: "POST", body: { email: email.trim().toLowerCase() }, auth: false });
      setSent(true);
    } catch (err) {
      toast.error(err.message || "Erreur");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-findo-navy text-white grid place-items-center px-4" data-testid="superadmin-forgot-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center gap-3 mb-8">
          <Logo size={34} withText textClass="text-xl text-white" />
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs font-bold tracking-wide ring-1 ring-white/15">
            <Shield size={14} /> Console Superadmin
          </span>
        </div>

        <FormCard icon={KeyRound} title="Mot de passe oublié" subtitle="Recevez un lien de réinitialisation sur l'email administrateur." className="text-slate-900 shadow-2xl" testid="superadmin-forgot-card">
          {sent ? (
            <div className="text-center space-y-4 py-2" data-testid="superadmin-forgot-sent">
              <div className="mx-auto h-14 w-14 grid place-items-center rounded-full bg-teal-50 text-teal-600">
                <MailCheck size={28} />
              </div>
              <p className="text-slate-600 text-sm">
                Si un compte administrateur existe pour cet email, un lien de réinitialisation vient d'être envoyé. Le lien est valable 1 heure.
              </p>
              <Link to="/superadmin/login">
                <Button variant="outline" className="rounded-xl" data-testid="superadmin-forgot-back">
                  Retour à la connexion
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <h1 className="sr-only">Mot de passe oublié</h1>
              <form onSubmit={submit} className="space-y-6" data-testid="superadmin-forgot-form">
                <div>
                  <Label htmlFor="sa-forgot-email">Email administrateur</Label>
                  <Input id="sa-forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="admin@findloop.io"
                    className="mt-1.5 h-11 rounded-xl"
                    data-testid="superadmin-forgot-email" />
                </div>
                <Button type="submit" disabled={loading}
                  className="w-full h-11 rounded-xl font-semibold bg-findo-red hover:bg-findo-red/90 text-white"
                  data-testid="superadmin-forgot-submit">
                  {loading ? <span className="inline-flex items-center gap-1.5"><FindoSpinner size={16} />Envoi…</span> : "Envoyer le lien"}
                </Button>
                <p className="text-center text-sm">
                  <Link to="/superadmin/login" className="font-semibold text-findo-red hover:underline">Retour à la connexion</Link>
                </p>
              </form>
            </>
          )}
        </FormCard>
      </div>
    </div>
  );
}
